import {get} from "lodash"
import {Deal} from "@irati/types"

export default function getLimits(deal: Deal) {
  const limits = get(deal, "productConfig.limits.perRedemption", null)
  const openValueLimits = get(deal, "productConfig.limits.forOpenValue", null)

  return {
    minPrice: get(limits, "minPriceBeforeDiscounts", null),
    maxPrice: get(limits, "maxPriceBeforeDiscounts", null),
    minOpenValuePrice: get(openValueLimits, "minValue", null),
    maxOpenValuePrice: get(openValueLimits, "maxValue", null),
    numItems: get(limits, "numberOfItems", null),
    numProducts: get(limits, "numberOfProducts", null)
  }
}
